import React, { forwardRef } from 'react';

// Gasco Imports
import { TextFieldTypes } from '@gasco/core';

// Styles
import './InputField.css';

type InputFieldProps = {
  className?: string;
  placeholder?: string;
  value?: string | number;
  type?: TextFieldTypes;
  onInput?: (event: any) => void;
  // Permitir pasar ref y otros props (como register)
  [key: string]: any;
}

const InputField = forwardRef<any, InputFieldProps>((props, ref) => {
  const handleInput = (event: any) => {
    if (props.onInput) {
      props.onInput(event);
    }
  }

  // Extraer las props que no son del gasco-input
  const { className, placeholder, value, type, onInput, ...rest } = props;

  return (
    <div className={className}>
      <gasco-input
        ref={ref}
        placeholder={placeholder || 'Ingrese un valor'}
        value={value}
        type={type || 'text'}
        onInput={handleInput}
        {...rest}
      ></gasco-input>
    </div>
  )
});

export default InputField;